var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        top: "30px",
        title: _vm.status == "create" ? "New member" : "Update member",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { rules: _vm.rules, model: _vm.form, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24, offset: 0 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Name", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: { size: "medium" },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Phone", prop: "phone" } },
                            [
                              _c("el-input", {
                                attrs: { size: "medium" },
                                model: {
                                  value: _vm.form.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "phone", $$v)
                                  },
                                  expression: "form.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Email", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { size: "medium" },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24, offset: 0 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8, offset: 0 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "City" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  on: { change: _vm.handleChangeCity },
                                  model: {
                                    value: _vm.form.receiverCityId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "receiverCityId", $$v)
                                    },
                                    expression: "form.receiverCityId",
                                  },
                                },
                                _vm._l(_vm.cities, function (item) {
                                  return _c("el-option", {
                                    key: item.ProvinceID,
                                    attrs: {
                                      label: item.ProvinceName,
                                      value: item.ProvinceID,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8, offset: 0 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "District" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  on: { change: _vm.handleChangeDistrict },
                                  model: {
                                    value: _vm.form.receiverDistrictId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "receiverDistrictId",
                                        $$v
                                      )
                                    },
                                    expression: "form.receiverDistrictId",
                                  },
                                },
                                _vm._l(_vm.districts, function (item) {
                                  return _c("el-option", {
                                    key: item.DistrictID,
                                    attrs: {
                                      label: item.DistrictName,
                                      value: item.DistrictID,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8, offset: 0 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Ward" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  on: { change: _vm.handleChangeWard },
                                  model: {
                                    value: _vm.form.receiverWardCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "receiverWardCode",
                                        $$v
                                      )
                                    },
                                    expression: "form.receiverWardCode",
                                  },
                                },
                                _vm._l(_vm.wards, function (item) {
                                  return _c("el-option", {
                                    key: item.WardCode,
                                    attrs: {
                                      label: item.WardName,
                                      value: item.WardCode,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Address" } },
                    [
                      _c("el-input", {
                        attrs: { size: "medium" },
                        model: {
                          value: _vm.form.receiverAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiverAddress", $$v)
                          },
                          expression: "form.receiverAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Notes" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 7, maxRows: 10 },
                        },
                        model: {
                          value: _vm.form.note,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "note", $$v)
                          },
                          expression: "form.note",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          [
            _vm.status == "update"
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn-delete",
                    attrs: { loading: _vm.loadingButton },
                    on: { click: _vm.handleDelete },
                  },
                  [_vm._v("Delete")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                staticClass: "btn-save",
                attrs: { type: "primary", loading: _vm.loadingButton },
                on: { click: _vm.handleApprove },
              },
              [_vm._v("Approve")]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn-save",
                attrs: { type: "primary", loading: _vm.loadingButton },
                on: { click: _vm.handleUpdateData },
              },
              [_vm._v("Update")]
            ),
          ],
          1
        ),
      ]),
      _c("approve-modal", {
        ref: "approveModal",
        on: {
          "submit:success": function ($event) {
            return _vm.$emit("submit:success")
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }